import { useQuery } from 'react-query'

import { useUmbrella } from '@modules-deprecated/app/umbrellas'
import { fetchUmbrellaRoles } from '@modules-deprecated/app/umbrellas/query-api'
import { UmbrellaRole } from '@modules-deprecated/app/umbrellas/types/umbrellaRole'

import { QueryKeys } from '../../../../../enums/queryKeys'

interface UseUmbrellaRolesResponse {
  data: UmbrellaRole[]
  isLoading: boolean
}

export const useUmbrellaRoles = (): UseUmbrellaRolesResponse => {
  const { umbrella } = useUmbrella()
  const umbrellaId = umbrella?.id || ''

  const {
    data: rolesData,
    isIdle,
    isLoading,
  } = useQuery([QueryKeys.UmbrellaRoles], () => fetchUmbrellaRoles(umbrellaId), {
    enabled: !!umbrellaId,
  })

  return {
    data: rolesData?.data || [],
    isLoading: isIdle || isLoading,
  }
}
